import { useZeroSelector } from "../../hooks/use-zero-selector.js";
import { queries } from "../queries";
import { useCurrentUser } from "../current-user";

const CACHE_KEY = "notifications.unreadByRecipient";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EMPTY_NOTIFICATIONS: any[] = [];
// Shallow copy — must create new reference because Zero's IVM mutates in place.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const selector = (data: readonly any[]) => [...data];

/** Unread notification events for inbox. */
export function useUnreadNotifications() {
  const { user } = useCurrentUser();
  return useZeroSelector(
    CACHE_KEY,
    user ? queries.notification_events.unreadByRecipient() : null,
    selector,
    { defaultValue: EMPTY_NOTIFICATIONS },
  );
}
